
import {define} from "observable:runtime";
import asset1 from "./style.css?url";
import asset2 from "./favicon.svg?url";

const assets = new Map([
  ["./style.css", asset1],
  ["./favicon.svg", asset2]
]);

define(
  {
    root: document.getElementById(`cell-2`),
    expanded: [],
    variables: []
  },
  {
    id: 2,
    body: async (html,display) => {
const {createUI, installHashImportBanner, installThemeToggle, runWithConsole, runTestCasesWithTimeout} = await import("./lib/helpers.js").then((module) => {
  if (!("createUI" in module)) throw new SyntaxError(`export 'createUI' not found`);
  if (!("installHashImportBanner" in module)) throw new SyntaxError(`export 'installHashImportBanner' not found`);
  if (!("installThemeToggle" in module)) throw new SyntaxError(`export 'installThemeToggle' not found`);
  if (!("runWithConsole" in module)) throw new SyntaxError(`export 'runWithConsole' not found`);
  if (!("runTestCasesWithTimeout" in module)) throw new SyntaxError(`export 'runTestCasesWithTimeout' not found`);
  return module;
});
installThemeToggle({ html, display });
installHashImportBanner({ html, display });
const { codeEditor, ok, err, hint, consoleOutput, testReport } = createUI({ html });
return {createUI,installHashImportBanner,installThemeToggle,runWithConsole,runTestCasesWithTimeout,codeEditor,ok,err,hint,consoleOutput,testReport};
},
    inputs: ["html","display"],
    outputs: ["createUI","installHashImportBanner","installThemeToggle","runWithConsole","runTestCasesWithTimeout","codeEditor","ok","err","hint","consoleOutput","testReport"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-5`),
    expanded: [],
    variables: []
  },
  {
    id: 5,
    body: (view,codeEditor) => {
const demo_template = view(codeEditor("builtins:template", {
  value: 'const name = "Sara"\nconst age = 17\n\n// Mit Plus:\nconsole.log("Hallo " + name + ", du bist " + age + " Jahre alt.")\n\n// Mit Template String:\nconsole.log(`Hallo ${name}, du bist ${age} Jahre alt.`)\n\n// Du kannst auch Ausdrücke einbauen:\nconsole.log(`Nächstes Jahr wirst du ${age + 1}.`)'
}));
return {demo_template};
},
    inputs: ["view","codeEditor"],
    outputs: ["demo_template"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-6`),
    expanded: [],
    variables: []
  },
  {
    id: 6,
    body: async (display,consoleOutput,runWithConsole,demo_template) => {
display(consoleOutput(await runWithConsole(demo_template)));
},
    inputs: ["display","consoleOutput","runWithConsole","demo_template"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-8`),
    expanded: [],
    variables: []
  },
  {
    id: 8,
    body: (view,codeEditor) => {
const demo_escape = view(codeEditor("builtins:escape", {
  value: 'console.log("Zeile 1\\nZeile 2")\nconsole.log("Sie sagte: \\"Hi\\".")\nconsole.log("Pfad: C:\\\\Users\\\\Anna")'
}));
return {demo_escape};
},
    inputs: ["view","codeEditor"],
    outputs: ["demo_escape"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-9`),
    expanded: [],
    variables: []
  },
  {
    id: 9,
    body: async (display,consoleOutput,runWithConsole,demo_escape) => {
display(consoleOutput(await runWithConsole(demo_escape)));
},
    inputs: ["display","consoleOutput","runWithConsole","demo_escape"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-11`),
    expanded: [],
    variables: []
  },
  {
    id: 11,
    body: (view,codeEditor) => {
const demo_length = view(codeEditor("builtins:length", {
  value: 'console.log("Hallo".length)        // 5\nconsole.log("".length)             // 0\nconsole.log("Mit Leerzeichen".length) // 15'
}));
return {demo_length};
},
    inputs: ["view","codeEditor"],
    outputs: ["demo_length"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-12`),
    expanded: [],
    variables: []
  },
  {
    id: 12,
    body: async (display,consoleOutput,runWithConsole,demo_length) => {
display(consoleOutput(await runWithConsole(demo_length)));
},
    inputs: ["display","consoleOutput","runWithConsole","demo_length"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-14`),
    expanded: [],
    variables: []
  },
  {
    id: 14,
    body: (view,codeEditor) => {
const demo_search = view(codeEditor("builtins:search", {
  value: 'const greeting = "Hallo Welt"\n\nconsole.log(greeting.startsWith("Hallo")) // true\nconsole.log(greeting.endsWith("Mond"))    // false\nconsole.log(greeting.includes("Welt"))    // true\nconsole.log(greeting.indexOf("Welt"))     // 6\nconsole.log(greeting.indexOf("Mars"))     // -1'
}));
return {demo_search};
},
    inputs: ["view","codeEditor"],
    outputs: ["demo_search"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-15`),
    expanded: [],
    variables: []
  },
  {
    id: 15,
    body: async (display,consoleOutput,runWithConsole,demo_search) => {
display(consoleOutput(await runWithConsole(demo_search)));
},
    inputs: ["display","consoleOutput","runWithConsole","demo_search"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-17`),
    expanded: [],
    variables: []
  },
  {
    id: 17,
    body: (view,codeEditor) => {
const demo_sub = view(codeEditor("builtins:substring", {
  value: 'const text = "JavaScript"\n\nconsole.log(text.substring(0, 4))  // "Java"\nconsole.log(text.substring(4))     // "Script" — ohne Ende-Index\nconsole.log(text.substring(4, 6))  // "Sc"'
}));
return {demo_sub};
},
    inputs: ["view","codeEditor"],
    outputs: ["demo_sub"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-18`),
    expanded: [],
    variables: []
  },
  {
    id: 18,
    body: async (display,consoleOutput,runWithConsole,demo_sub) => {
display(consoleOutput(await runWithConsole(demo_sub)));
},
    inputs: ["display","consoleOutput","runWithConsole","demo_sub"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-20`),
    expanded: [],
    variables: []
  },
  {
    id: 20,
    body: (view,codeEditor) => {
const uebung1_code = view(codeEditor("builtins:final1", {
  value: ""
}));
return {uebung1_code};
},
    inputs: ["view","codeEditor"],
    outputs: ["uebung1_code"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-21`),
    expanded: [],
    variables: []
  },
  {
    id: 21,
    body: (runTestCasesWithTimeout,uebung1_code) => {
const uebung1Result = runTestCasesWithTimeout({
  code: uebung1_code,
  fnName: "removeSalutation",
  cases: [
    [["Fr. Black Widow"], "Black Widow"],
    [["Hr. Hulk"], "Hulk"],
    [["Thor"], "Thor"],
    [["Fr. Mariane Liemann"], "Mariane Liemann"]
  ]
});
return {uebung1Result};
},
    inputs: ["runTestCasesWithTimeout","uebung1_code"],
    outputs: ["uebung1Result"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-22`),
    expanded: [],
    variables: []
  },
  {
    id: 22,
    body: (display,testReport,uebung1Result) => {
display(testReport(uebung1Result, "removeSalutation"));
},
    inputs: ["display","testReport","uebung1Result"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-24`),
    expanded: [],
    variables: []
  },
  {
    id: 24,
    body: (view,codeEditor) => {
const uebung2_code = view(codeEditor("builtins:final2", {
  value: ""
}));
return {uebung2_code};
},
    inputs: ["view","codeEditor"],
    outputs: ["uebung2_code"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-25`),
    expanded: [],
    variables: []
  },
  {
    id: 25,
    body: (runTestCasesWithTimeout,uebung2_code) => {
const uebung2Result = runTestCasesWithTimeout({
  code: uebung2_code,
  fnName: "removeString",
  cases: [
    [["FooBarFoo", "Foo"], "Bar"],
    [["Man darf auf der Akademie nicht Geschi sagen", "Geschi"], "Man darf auf der Akademie nicht  sagen"],
    [["Info ist der beste Kurs", "Mathe"], "Info ist der beste Kurs"],
    [["XYZXYZ", "Z"], "XYXY"],
    [["ABCDE", "CD"], "ABE"]
  ]
});
return {uebung2Result};
},
    inputs: ["runTestCasesWithTimeout","uebung2_code"],
    outputs: ["uebung2Result"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-26`),
    expanded: [],
    variables: []
  },
  {
    id: 26,
    body: (display,testReport,uebung2Result) => {
display(testReport(uebung2Result, "removeString"));
},
    inputs: ["display","testReport","uebung2Result"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
